import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { DisplayM } from '@sorare/core/src/atoms/typography';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

import careers from '../assets/careers.jpg';
import values from '../assets/values.svg';
import { ImageSection, ResetFontSizeContainer, StyledContainer } from '../ui';

const CareersTitle = styled(DisplayM)`
  font-size: 52px;
  line-height: 1;
  color: var(--c-white);
  margin-bottom: var(--double-unit);
  @media ${laptopAndAbove} {
    font-size: 128px;
  }
`;

const CareersSection = styled(ImageSection)`
  aspect-ratio: 18/6;
  background-image: url(${careers});
`;
const ValuesBand = styled.div`
  width: 100%;
  height: 30px;
  position: absolute;
  bottom: 5px;

  background-image: url(${values});
  background-repeat: repeat-x;
  @media ${laptopAndAbove} {
    bottom: 0;
  }
`;

export const Careers = () => {
  return (
    <ResetFontSizeContainer>
      <CareersSection
        vAlignContent="bottom"
        blackLayer="bottom"
        keepImageOnMobile
      >
        <StyledContainer>
          <div>
            <CareersTitle as="h1">Careers</CareersTitle>
            <Button color="tertiary" size="large" to="#jobs">
              View job openings
            </Button>
          </div>
        </StyledContainer>
        <ValuesBand />
      </CareersSection>
    </ResetFontSizeContainer>
  );
};
